import { Model } from '../parents/model';

export class CustomerModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_EMAIL = 'email';
  static ATTR_FIRST_NAME = 'first_name';
  static ATTR_LAST_NAME = 'last_name';

  get id() {
    return this.attributes[CustomerModel.ATTR_ID];
  }
  get email() {
    return this.attributes[CustomerModel.ATTR_EMAIL];
  }
  get firstName() {
    return this.attributes[CustomerModel.ATTR_FIRST_NAME];
  }
  get lastName() {
    return this.attributes[CustomerModel.ATTR_LAST_NAME];
  }
}
